// AI Polish — uses the buyer's Groq API key (from Settings) to polish a section.
// The PWA works fully without this; the key is optional.

import { streamGroq, GroqMissingKeyError } from './groq-client';

export async function aiPolishSection(
  sectionTitle: string,
  sectionContent: string,
  templateType: string,
  onStream: (chunk: string) => void
): Promise<void> {
  const system = `You are a senior consultant. Rewrite this ${templateType} section titled "${sectionTitle}". Maintain all facts. Improve tone, flow, and impact. Use active voice. Add professional transition sentences. Output only the polished content, no explanations.`;
  try {
    await streamGroq({
      messages: [
        { role: 'system', content: system },
        { role: 'user', content: `Section: ${sectionTitle}\n\nContent: ${sectionContent}\n\nProduce the polished version.` },
      ],
      temperature: 0.3,
      onStream,
    });
  } catch (err) {
    if (err instanceof GroqMissingKeyError) {
      onStream('\n\n⚠️ No Groq API key set. Click the Settings gear ⚙ in the header to paste your free key from console.groq.com/keys. The core logic above works fully without it.');
      return;
    }
    onStream(`\n\n⚠️ ${err instanceof Error ? err.message : 'Groq error'}`);
  }
}
